import {FC} from 'react';
//mui
import {Box, Typography} from '@mui/material';
//components
import ActionsMenu from '@/shared/components/Table/ActionMenu';
//constants
import {H6, VIEW_DETAILS} from '@/utils/constants';
//styles
import {statisticsInfoItemStyle} from './StatisticsInfoItem.styles';

interface StatisticsInfoItemProps {
	icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
	title: string | number;
	description: string;
	onClick: (key: string) => void;
}

const StatisticsInfoItem: FC<StatisticsInfoItemProps> = ({icon: Icon, title, description, onClick}) => {
	const handleStatisticClick = (title: string) => () => onClick(title);

	return (
		<Box sx={statisticsInfoItemStyle.statistic}>
			<Box sx={statisticsInfoItemStyle.icon}>
				<Icon />
			</Box>

			<Typography variant={H6}>{title}</Typography>

			<Typography sx={statisticsInfoItemStyle.description}>{description}</Typography>

			<Box sx={statisticsInfoItemStyle.dropdown}>
				<ActionsMenu
					content={
						<Box sx={statisticsInfoItemStyle.action} onClick={handleStatisticClick(description)}>
							{VIEW_DETAILS}
						</Box>
					}
					parentClassName={statisticsInfoItemStyle.dropdownIcon}
					disableRipple
				/>
			</Box>
		</Box>
	);
};

export default StatisticsInfoItem;
